/*
  Ссылка на материал на сайте.

  Мнение эксперта — тип материала, но в ссылке /expert/<номер> идёт не pk,
  а публичный номер expert_url_id: у записей, перенесённых из старой
  таблицы мнений, они не совпадают. В части ручек (поиск, by-expert-url)
  публичный номер приезжает уже в поле id, поэтому берём expert_url_id,
  а при его отсутствии — id.
*/

interface MaterialLinkSource {
  id: number;
  type?: string | null;
  expert_url_id?: number | null;
  redirect?: string | null;
}

const EXPERT_TYPES = ['expert', 'experts'];

export const isExpertMaterial = (type?: string | null): boolean =>
  Boolean(type && EXPERT_TYPES.includes(type));

/* Публичный идентификатор записи: у мнений — номер для /expert/<номер>. */
export const getMaterialPublicId = (item: MaterialLinkSource): number =>
  isExpertMaterial(item.type) ? (item.expert_url_id ?? item.id) : item.id;

/*
  Путь до материала. Внешний redirect имеет приоритет: он задаётся
  редактором и ведёт за пределы сайта.
*/
export const getMaterialLink = (item: MaterialLinkSource): string => {
  if (item.redirect) {
    return item.redirect;
  }

  if (isExpertMaterial(item.type)) {
    return `/expert/${getMaterialPublicId(item)}`;
  }

  return `/${item.type}/${item.id}`;
};
